<script>
    // Import multiselect component
    import Multiselect from 'vue-multiselect';

    // Import general mixin for shared functionality.
    import mixin from '../../../mixin';

    export default {
        mixins: [mixin],
        components: {
            Multiselect
        },
        props: {
            dossiers: Array,
            activeFilters: Array,
        },
        data() {
            return {
                activeFilter: [],
                isOpened: false,
                name: 'statusExternal',
            };
        },
        watch: {
            activeFilters: function (newVal, oldVal) {
                let filter = newVal.find(filter => filter.type === this.name);
                this.activeFilter = filter ? filter.value : [];
            }
        },
        computed: {
            filteredDossiers() {
                if (!this.dossiers || !this.dossiers.length) return [];
                if (!this.activeFilters || !this.activeFilters.length) return this.sortDossiersByDate(this.dossiers);
                let filteredDossiers = this.filterDossiers(this.dossiers, this.activeFilters, [this.name]);
                return this.sortDossiersByDate(filteredDossiers);
            },
            options() {
                if (!this.filteredDossiers.length) return [];
                return this.sortArray(this.removeDuplicates(this.filteredDossiers.map(dossier => dossier.status_extern_label)));
            },
            showAllLabel() {
                return this.activeFilter.length || this.isOpened;
            },
        },
        methods: {
            onChange() {
                this.$emit('filter', {
                    type: this.name,
                    value: this.activeFilter
                });
            },
            close() {
                this.$refs.multiselect.deactivate();
            }
        }
    };
</script>

<template>
    <div v-if="options.length" class="dashboard-widget dashboard-widget--filter">
        <label for="statusExternal" class="is-nowrap is-size-10 has-text-dark-blue">{{ $store.getters.getText('casesearchFilterStatus') }}</label>
        <multiselect    ref="multiselect"
                        id="statusExternal"
                        v-model="activeFilter"
                        @select="onChange"
                        @remove="onChange"
                        :options="options"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :placeholder="showAllLabel ? '' : $store.getters.getText('casesearchLabelAll')"
                        :showLabels="false"
                        @open="isOpened = true"
                        @close="isOpened = false">
            <template v-slot:noResult>
                <span>{{ $store.getters.getText('casesearchLabelNoresults') }}</span>
            </template>
        </multiselect>
    </div>
</template>
